import { getUserAccessTokenCookie, getUserFromCookie } from './localStorage';

export const TOKEN_ONLY_SESSION = 'token-only';

// The signed-in session that requests are sent for (CON-8904): the user from
// the user cookie or, once that cookie has expired (it lasts a month and is
// not renewed) while the refreshed access token is still sent, a session with
// only the token left. null when requests are sent without a token.
const getSessionKey = () => {
  const userId = getUserFromCookie()?.id;

  if (userId != null) {
    return userId;
  }

  const accessToken = getUserAccessTokenCookie();

  return accessToken && accessToken !== 'undefined' ? TOKEN_ONLY_SESSION : null;
};

export default getSessionKey;
